import React from 'react';

export default function CardAccent({ color }) {
	return <div className="card-accent" style={{ background: color }} />;
}
